




















































import type { PropType } from '@nuxtjs/composition-api';
import { computed, defineComponent, ref, toRef, watch } from '@nuxtjs/composition-api';
import { SfAccordion, SfHeading, SfImage, SfLink, SfList } from '@storefront-ui/vue';
import AccordionItemToggleIcon from '~/components/General/AccordionItemToggleIcon.vue';
import SvgImage from '~/components/General/SvgImage.vue';
import Tooltip from '~/components/Tooltip.vue';
import { useProduct } from '~/composables';
import ProductAnalysesSkeleton from '~/modules/catalog/product/components/loading/ProductAnalysesSkeleton.vue';
import { useAnalysesStore } from '~/modules/catalog/product/stores/analyses';
import { CustomCategoryTree } from '../../types';

export default defineComponent({
  name: 'ProductAnalyses',
  components: {
    SfAccordion,
    SfHeading,
    SfLink,
    SfList,
    SfImage,
    ProductAnalysesSkeleton,
    SvgImage,
    Tooltip,
    AccordionItemToggleIcon,
  },
  props: {
    analysesCategories: Array as PropType<CustomCategoryTree[]>,
    title: {
      type: String,
      required: false,
    },
    activeProductSku: {
      type: String,
      required: false,
    },
    backLink: {
      type: String,
      required: false,
    },
  },
  setup(props) {
    const { getProductPath } = useProduct();
    const analysesStore = useAnalysesStore();
    const openCategories = computed(() => analysesStore.openCategories);
    // eslint-disable-next-line
    const setOpenCategories = analysesStore.setOpenCategories;
    const analysesCategoriesRef = toRef(props, 'analysesCategories');
    const activeProductSku = toRef(props, 'activeProductSku');
    const initialOpenCategories = ref(['']);

    const openAccordionItem = (accordionClick: any, categoryName: string) => {
      accordionClick();
      const categoryNameIndex = analysesStore.openCategories.indexOf(categoryName);

      // // Only way I could stop it from throwing TypeError: Cannot read properties of undefined (reading '_uid') ...
      // // I mean it's only an array of max 15 strings, it didn't take more than .05ms to parse on MacBook Pro
      const parsedobj: string[] = JSON.parse(JSON.stringify(analysesStore.openCategories));

      if (categoryNameIndex === -1) {
        setOpenCategories([...parsedobj, categoryName]);
        return;
      }
      setOpenCategories(parsedobj.filter((_, index) => index !== categoryNameIndex));
    };

    watch(
      analysesCategoriesRef,
      () => {
        if (!analysesCategoriesRef.value[0] || openCategories.value.length > 0) {
          initialOpenCategories.value = openCategories.value;
          return;
        }
        const activeCategory =
          analysesCategoriesRef.value.find((category) => category.products.items.some((product) => product.sku === activeProductSku.value)) ||
          analysesCategoriesRef.value[0];
        setOpenCategories([activeCategory.name]);
        initialOpenCategories.value = [activeCategory.name];
      },
      { deep: true, immediate: true },
    );

    return {
      getProductPath,
      openAccordionItem,
      initialOpenCategories,
    };
  },
});
